import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6skkh4xxa: FaireProductEntity = {
  token: "p_q6skkh4xxa",
  type: "product",
  name: "Seven Chakra Stone Spheres - 40mm (Approx. 1 Pound Bag)",
  brandToken: "b_4w78fajgal",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ff40ca664d7de150eb733f11066b25404eee8b6c7b6bfed9b7a06e0594a44a6a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e271e4e7ede3d96fcb83c555d5afdf36f250abb52683043f22c059687a433a4.png",
  ],
  priceDollars: 69.29,
  description:
    "Beautiful seven chakra 40mm Spheres sold in 1 Pound increments.\n\nApproximately 5 Spheres in 1 Lbs\n\nIt is believed that the Seven Chakra Sphere can help to balance energy, clear negativity, and promote overall well-being. It is said to enhance meditation, spiritual healing, and energy alignment, promoting inner peace and balance. These spheres are expertly cut, shaped, and polished.\nThe dimensions of sphere are approximately: 40MMM\n\nThis picture is an representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product.",
  tags: [],
  msrpDollars: 138.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:18.490Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
